import { call, put, takeLatest } from 'redux-saga/effects';
import { ACTIONS_TYPES } from "../utils/constants";
import { getProjects, registerProject, suspendProject } from '../utils/requests';
import { fetchProjectsSuccess, fetchProjectsFailed, registerProjectSuccess, registerProjectFailed, fetchProjectsRequest, suspendProjectSuccess, suspendProjectFailed  } from '../actions/project';

export function* projectWatcherSaga() {
  yield takeLatest(ACTIONS_TYPES.FETCH_PROJECTS_REQUEST, projectRequestWatcher);
}

function* projectRequestWatcher() {
    try {
      const response = yield call(getProjects);

      yield put(fetchProjectsSuccess(response.data));

    } catch(error) {
      let errorPayload = {};
      if (error.response) {
        errorPayload = error.response.data;
      }
      yield put(fetchProjectsFailed(errorPayload));
    }
}

export function* registerProjectWatcherSaga() {
  yield takeLatest(ACTIONS_TYPES.REGISTER_PROJECT_REQUEST, registerProjectRequestWatcher);
}



function* registerProjectRequestWatcher(action) {
    try {
      const { payload } = action;
      const response = yield call(registerProject, payload);

      yield put(registerProjectSuccess(response.data));
      console.log("createdProject");
      

    } catch(error) {
      let errorPayload = {};
      if (error.response) {
        errorPayload = error.response.data;
      }
      console.log("registerProjectError: ",error.response);
      
      yield put(registerProjectFailed(errorPayload));
    }
}

export function* suspendProjectWatcherSaga() {
  yield takeLatest(ACTIONS_TYPES.SUSPEND_PROJECT_REQUEST, suspendProjectRequestWatcher);
}



function* suspendProjectRequestWatcher(action) {
    try {
      const { payload } = action;
      const response = yield call(suspendProject, payload);

      yield put(suspendProjectSuccess(response.data));
      yield put(fetchProjectsRequest());

      console.log("createdProject");
      

    } catch(error) {
      let errorPayload = {};
      if (error.response) {
        errorPayload = error.response.data;
      }
      console.log("suspendProjectError: ",error.response);
      
      yield put(suspendProjectFailed(errorPayload));
    }
}